export const CognitoIdTokenPayLoadKey = 'cognitoIdTokenPayLoad'
export const CognitoIdTokenKey = 'cognitoIdToken'
export const CognitoAccessTokenKey = 'cognitoAccessToken'
export const CognitoRefreshTokenKey = 'cognitoRefreshToken'
export const UserRole = 'role'
export const RedirectPath = 'redirectPath'
export const SourcePath = 'sourcePath'
